"use client";

import { useOptionalPlan } from "@/contexts/plan-context";
import useBoundStore from "@/store/bound-store";
import { shouldExcludePaidFeatures } from "@/utils/paid-feature-exclusion";

export interface PaidFeatureExclusionState {
  isPaidFeatureExcluded: boolean;
  isPlanLoading: boolean;
}

export function usePaidFeatureExclusion(): PaidFeatureExclusionState {
  const person = useBoundStore.use.person();
  const planContext = useOptionalPlan();
  const plan = planContext?.plan ?? null;

  return {
    isPaidFeatureExcluded: shouldExcludePaidFeatures(person, plan),
    isPlanLoading: planContext?.isLoading ?? false,
  };
}
